import React, { Fragment } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Typography } from "@mui/material";
import Labels from "../labels/Labels";

export default function CardCredits(props) {
  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 70,
      renderCell: (params) => {
        return (
          <Typography sx={{ fontSize: 12, mb: 0 }} gutterBottom>
            {params.row.periodStartDate}
          </Typography>
        );
      },
    },
    {
      field: "transactionDate",
      headerName: Labels.getLabel(
        "cardCredits.transactionDate",
        "Transaction Date"
      ),
      width: 140,
      renderCell: (params) => {
        return (
          <Typography sx={{ fontSize: 12, mb: 0 }} gutterBottom>
            {params.row.transactionDate}
          </Typography>
        );
      },
    },
    {
      field: "amount",
      headerName: Labels.getLabel("cardCredits.amount", "Amount"),
      width: 90,
      renderCell: (params) => {
        return (
          <Typography sx={{ fontSize: 12, mb: 0 }} gutterBottom>
            {params.row.amount}
          </Typography>
        );
      },
    },
    {
      field: "category",
      headerName: Labels.getLabel("cardCredits.category", "Category"),
      width: 150,
      renderCell: (params) => {
        return (
          <Typography sx={{ fontSize: 12, mb: 0 }} gutterBottom>
            {params.row.category}
          </Typography>
        );
      },
    },
    {
      field: "description",
      headerName: Labels.getLabel("cardCredits.description", "Description"),
      width: 170,
      renderCell: (params) => {
        return (
          <Typography sx={{ fontSize: 12, mb: 0 }} gutterBottom>
            {params.row.description}
          </Typography>
        );
      },
    },
    {
      field: "merchant",
      headerName: Labels.getLabel("cardCredits.merchant", "Merchant"),
      width: 170,
      renderCell: (params) => {
        return (
          <Typography sx={{ fontSize: 12, mb: 0 }} gutterBottom>
            {params.row.merchant}
          </Typography>
        );
      },
    },
  ];
  const { isLoading, isError, data } = props;
  return (
    <Fragment>
      {isLoading ? (
        <h4>{Labels.getLabel("cardCredits.loading", "Loading...")}</h4>
      ) : !isError ? (
        <div style={{ height: 300, width: "100%" }}>
          <DataGrid
            columnVisibilityModel={{ id: false }}
            disableSelectionOnClick
            disableColumnFilter
            disableColumnSelector
            disableDensitySelector
            rows={data?.data}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            components={{ Toolbar: GridToolbar }}
            componentsProps={{
              toolbar: {
                showQuickFilter: false,
                quickFilterProps: { debounceMs: 500 },
              },
            }}
            sx={{
              "& .MuiButton-root": {
                display: "none",
              },
            }}
          />
        </div>
      ) : (
        <h4>
          {Labels.getLabel(
            "cardCredits.error",
            "An error ocurred, please try again later..."
          )}
        </h4>
      )}
    </Fragment>
  );
}
